// extracted by css-extract-rspack-plugin
module.exports =  {"buttonPreferredSources":"sgLJV","floatingButton":"pN79w","visible":"heilg"};